import { render } from "./DealerSalesPanel.vue?vue&type=template&id=5d2d3d34&scoped=true"
import script from "./DealerSalesPanel.vue?vue&type=script&lang=js"
export * from "./DealerSalesPanel.vue?vue&type=script&lang=js"

import "./DealerSalesPanel.vue?vue&type=style&index=0&id=5d2d3d34&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d2d3d34"]])

export default __exports__